import layout from './layout/LayoutConfig';

const LayoutConfigs = {
    layout
};

export default LayoutConfigs;
